<template>

  <v-text-field
    tabindex=-1
    :style="adjustStyle"
    v-bind="computedProps"
    v-on="computedListeners"/>

</template>
<script>
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用件数表示テキスト
 * @namespace components
 */

/**
 * @vue-prop {String} [lebel=''] - 表示ラベル
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
 * <dd-row-count-box
 *   :label="counterLabel"/>
 */
export default {
  name: 'DdRowCountBox',
  extends: VTextField,
  props: {
    /**
     * 表示用ラベル
     */
    label: String,
    /**
     * スタイル指定
     */
    adjustStyle: {
      type: String,
      default: 'padding-top:16px'
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        readonly: true,
        label: this.label,
        placeholder: '　',
        suffix: '件',
        class: ' px-1 input-right',
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.input-right /deep/ input {
  text-align: right;
}
</style>
